import React from 'react';

export default class AdComponent extends React.Component {
  componentDidMount () {
    (window.adsbygoogle = window.adsbygoogle || []).push({});
  }

render () {
    return (
    //     <ins className="adsbygoogle"
    //  style={{display:'block'}}
    //  data-ad-client="ca-pub-6913412218612382"
    //  data-ad-slot="2025752442"
    //  data-ad-format="auto"
    //  data-adtest="on"
    //  data-full-width-responsive="true"/>

    // <div className="ad">
    // <ins className="adsbygoogle"
    //  style={{display:'block'}}
    //  data-ad-client="ca-pub-6913412218612382"
    //  data-ad-slot="4624742078"
    //  data-ad-format="auto"
    //  data-adtest="on"
    //  data-full-width-responsive="true"/>
    //  </div>
<div className="bg-black">
<ins class="adsbygoogle"
     style={{display:'block'}}
     data-ad-client="ca-pub-6913412218612382"
     data-ad-slot="4624742078"
     data-ad-format="auto"
     data-full-width-responsive="true"></ins>
</div>
    );
  }
}